import React from 'react';
import styled from 'styled-components'

import { Box } from 'vqp-common'
import { Icon } from '../common'

const Card = styled(Box)`
    padding: 5px 15px;
    color: ${props => props.theme.colors[props.color]} !important;
`

const TitleAndIconRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

const Title = styled.div`
    font-size: 15px;
    font-weight: 700;
    max-width: 50%;
` 

const Value = styled.div`
    font-size: 30px;
    font-weight: 700;
    width: 100%;
    padding-top: 30px;
    text-align: right;
`

export const SmallInfoCard = ({title, icon, color, value}) => (
    <Card color={color}>
        <TitleAndIconRow>
            <Title>{title}</Title>
            <Icon name={icon} stroke={color} fill={color} />
        </TitleAndIconRow>
        <Value>{value}</Value>
    </Card>
)

